/** @jsxImportSource @emotion/react */
import React from "react";
import { useSwitchNetwork } from "wagmi";
import styled from "@emotion/styled";
import { CHAINS } from "config/chains";

export interface NetworkRowProps {
  networkName: string;
  icon: React.ReactNode;
  networkId: number;
}

export const NetworkRow: React.FC<NetworkRowProps> = props => {
  const { switchNetwork } = useSwitchNetwork();
  return (
    <NetworkRowContainer onClick={() => switchNetwork?.(props.networkId)}>
      <div>{props.icon}</div>
      <span>{CHAINS[props.networkId].displayName}</span>
    </NetworkRowContainer>
  );
};

const NetworkRowContainer = styled.div`
  width: 100%;
  background: ${props => props.theme.surface.main.secondary.default};
  border-radius: 12px;
  padding: 12px;
  font-family: ${props => props.theme.fontFamilies.Primary};
  font-size: ${props => props.theme.fontSize["5"]};
  font-weight: ${props => props.theme.fontWeights["work-sans-2"]};
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
